import { TError, TProDirectory } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';
import { TEACHER_DIRECTORY_PATH } from './entity';

export const getProDirectoryQueryKey = () => ['pro-directory'];

type TParams = {
  enabled?: boolean;
};

// Lazy: pro_directory is intentionally separate from useGetAllProfileQuery and
// is NOT merged into the global profile cache. Only call this hook from pages
// that actually need pro info (e.g. the Pro Directory tab).
export const useGetProDirectoryQuery = (params?: TParams) => {
  const enabled = params?.enabled ?? true;

  return useQuery<TProDirectory | null, TError>({
    queryKey: getProDirectoryQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TProDirectory | null>(`/${TEACHER_DIRECTORY_PATH}`);
      return res.data ?? null;
    },
    enabled,
    refetchOnWindowFocus: false,
  });
};

export type TUseGetProDirectoryQueryResult = ReturnType<typeof useGetProDirectoryQuery>;
